import { defineAsyncComponent } from "vue";
import { getI18n } from "@editor/ui-utils";
const de = {
  articlesBoxApi: {
    createAlreadyExists: "ArticlesBox kann nicht erstellt werden, da bereits ein ArticlesBox mit diesem Namen existiert",
    updateAlreadyExists: "ArticlesBox kann nicht aktualisiert werden, da bereits ein ArticlesBox mit diesem Namen existiert",
    created: "ArticlesBox erstellt",
    updated: "ArticlesBox aktualisiert",
    notFound: "ArticlesBox nicht gefunden",
    requiredFields: "Sie können den ArticlesBox nicht speichern, da obligatorische Informationen fehlen"
  },
  articlesBoxList: {
    newButton: "Neue Interne LinkBox",
    search: "Nach Titel oder ID suchen",
    deleteArticlesBox: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade ArticlesBox",
    description: "Beschreibung",
    title: "Titel",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createArticlesBox: "Linkbox erstellen",
    boxId: "Box-ID",
    articleLinksCount: "Artikel"
  },
  articlesBox: {
    selectorPlaceholder: "Interne Linkliste auswählen",
    showImagesCheckboxLabel: "Als Liste mit Bildern anzeigen",
    editBox: "Liste bearbeiten",
    articlesBoxLabel: "Interne Linkbox",
    backButton: "Zurück zur ArticlesBox-Liste",
    newArticlesBox: "Neue Linkbox",
    messageDeleteArticlesBox: "ArticlesBox löschen",
    messageDeleteArticlesBoxTitle: "Sind Sie sicher, dass Sie dieses ArticlesBox löschen möchten?",
    deleteArticlesBox: "Löschen",
    messageDeleted: "ArticlesBox gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des ArticlesBoxs",
    errorFailedLoadedArticlesBoxWithId: "Es gab einen Fehler beim Abrufen des ArticlesBoxs",
    description: "Beschreibung",
    contentBlockLabel: "INTERNE LINKBOX"
  },
  articlesBoxEdit: {
    title: "Titel",
    description: "Beschreibung (intern)",
    backButton: "Zurück zur ArticlesBox-Liste",
    editArticlesBox: "Box bearbeiten",
    messageSaved: "Neue Box gespeichert",
    linkArticlesButton: "Artikel verlinken",
    addLinkButton: "Link hinzufügen",
    addLink: "Link hinzufügen",
    linkTitle: "Link-Titel",
    linkUrl: "Link-URL",
    openIn: "Öffnen in",
    sameWindow: "Im gleichen Fenster öffnen",
    newWindow: "In neuem Fenster öffnen",
    brandChangeTitle: "Markenwechsel",
    brandChangeMessage: "Alle zugehörigen Artikel werden entfernt, wenn die Marke geändert wird. Möchten Sie fortfahren?",
    teaserImage: "Teaser-Bild",
    teaserImageTooltip: "Wähle ein Bild für diesen Link in der Linkliste.",
    teaserImageDescription: "Bild auswählen oder hochladen"
  }
};
const en = {
  articlesBoxApi: {
    createAlreadyExists: "Can't create ArticlesBox because another ArticlesBox with this name already exists",
    // TODO: is it used?
    updateAlreadyExists: "Can't update ArticlesBox because another ArticlesBox with this name already exists",
    // TODO: is it used?
    created: "ArticlesBox created",
    updated: "ArticlesBox updated",
    notFound: "ArticlesBox not found",
    requiredFields: "You can't save the ArticlesBox because mandatory information is missing"
  },
  articlesBoxList: {
    newButton: "New internal LinkBox",
    search: "Search by Title or ID",
    deleteArticlesBox: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading ArticlesBox",
    description: "Description",
    title: "Title",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createArticlesBox: "Create LinkBox",
    boxId: "Box ID",
    articleLinksCount: "Articles"
  },
  articlesBox: {
    selectorPlaceholder: "Select related articles box",
    showImagesCheckboxLabel: "Show as list with images",
    editBox: "Edit list",
    articlesBoxLabel: "Related Articles",
    backButton: "Back to ArticlesBox list",
    newArticlesBox: "New LinkBox",
    messageDeleteArticlesBox: "Delete ArticlesBox",
    messageDeleteArticlesBoxTitle: "Are you sure you want to delete this ArticlesBox?",
    deleteArticlesBox: "Delete",
    messageDeleted: "ArticlesBox Deleted",
    errorOnDeleting: "There was an error deleting the ArticlesBox ",
    errorFailedLoadedArticlesBoxWithId: "There was an error getting the ArticlesBox",
    description: "Description",
    contentBlockLabel: "Related Articles"
  },
  articlesBoxEdit: {
    title: "Title",
    description: "Description",
    backButton: "Back to ArticlesBox list",
    editArticlesBox: "Edit Box",
    messageSaved: "New Box saved",
    linkArticlesButton: "Link articles",
    addLinkButton: "Link",
    addLink: "Add link",
    linkTitle: "Link title",
    linkUrl: "Link URL",
    openIn: "Open in",
    sameWindow: "Open in same window",
    newWindow: "Open in new window",
    brandChangeTitle: "Brand change",
    brandChangeMessage: "All related articles will be removed when the brand will be changed. Do you want to continue?",
    teaserImage: "Teaser Image",
    teaserImageTooltip: "Select an image to be displayed with this link. The image will be shown in the list view.",
    teaserImageDescription: "Select or upload an image"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/articles-box",
    children: [
      {
        path: "",
        name: "articles_box_list",
        component: () => import("./articles-box-list.view-CSeKOIQ6.js"),
        meta: { requiredRight: "navigate_list_articles_box" }
      },
      {
        path: "new",
        name: "articles_box_new",
        component: () => import("./articles-box-edit.view-BUgYfS03.js"),
        props: () => ({
          title: getI18n().t("articlesBox.newArticlesBox"),
          backRoute: "/articles-box"
        }),
        meta: { requiredRight: ["navigate_articles_box"] }
      },
      {
        path: ":id",
        name: "articles_box_detail",
        component: () => import("./articles-box-edit.view-BUgYfS03.js"),
        props: (route) => ({
          title: getI18n().t("articlesBoxEdit.editArticlesBox"),
          id: route.params.id,
          backRoute: "/articles-box"
        }),
        meta: { requiredRight: ["navigate_articles_box"] }
      }
    ]
  }
];
const ArticlesBoxContentBlock = defineAsyncComponent(() => import("./articles-box-content-block-sWowUmBO.js"));
const articlesBoxModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "ARTICLES_BOX",
      label: "articlesBox.contentBlockLabel",
      icon: "link",
      component: ArticlesBoxContentBlock,
      defaultValue: { type: "ARTICLES_BOX", showImages: false }
    }
  ]
};
export {
  ArticlesBoxContentBlock,
  articlesBoxModule
};
//# sourceMappingURL=index.es.js.map
